import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'ngx-modal-template',
  templateUrl: './modal-template.component.html',
  styleUrls: ['./modal-template.component.scss']
})
export class ModalTemplateComponent implements OnInit {

  @Input() title: any;
  @Input() messaggio: any;

  constructor(protected ref: NbDialogRef<ModalTemplateComponent>, private _sanitizer: DomSanitizer) { }

  ngOnInit() {
    this.messaggio= this._sanitizer.bypassSecurityTrustHtml(this.messaggio)
  }

  dismiss() {
    this.ref.close();
  }

}
